<template>
	<div id="usre-baseinfor" class="oh">
		<!-- 政府端 -->
		<leftnav class="fl" mkcode="E" itemcode="E-GXJSQ"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader :show-video="true" :video-type="5"></govheader>
			<div class="index_left_centerpage whitebox" style="min-height: 1000px;">
				<div v-if="userdata.token">
					<!--   style="min-height: 800px;" -->
					<div class="whitebox right_topbox">
						<div class="right_boxtitle">
							<span class="fl right_title">企业-企业关系计算器</span>
							<span class="fr rightlink curp" @click="routerself('/userrelational')">我的关系网</span>
							<vedioTips :type="8" class="pt-1 pl-10 ml-3"></vedioTips>
						</div>
						<ul class="user_tabtitle1" style="margin-top:16px;display:none">
							<!-- <li :class="pagetype == 1?'current':''" @click="pageToggle(1)">单个关系计算器</li> -->
							<!-- <li :class="pagetype == 2?'current':''" @click="pageToggle(2)">批量关系计算器</li> 批量关系器暂时隐藏删除-->
						</ul>

						<div class="relationCa oh" v-show="pagetype == 1">
							<div class="fl">
								<div class="titlebox">
									<h5 class="fl ">我熟悉的企业</h5>
									<el-tooltip class="item smartTip-text" effect="light" placement="left-start"><i
											class="el-icon-question listeltootipicon"></i>
										<div slot="content" class="list_tips">
											<p>批量添加：如果有完整的企业名单，可以一键复制粘贴。请确保企业全称正确，每行一个企业。</p>
											<p>单个添加：在不确定企业名称的情况下，可输入关键词进行搜索，逐个添加。</p>
										</div>
									</el-tooltip>
									<span class="addclick basebtn fr ml-3"
										@click="showtype = 'chooseconversantSingle'; popbtn = true; tipstext = ''; tipstext1 = '';">单个添加</span>
									<span class="addclick basebtn fr "
										@click="showtype = 'chooseconversant'; popbtn = true; tipstext = ''; tipstext1 = '';">批量添加</span>
								</div>
								<ul>
									<li :key="index" v-for="(item, index) in conversantlistTem">
										<span class="fl"><input type="checkbox" class="websit-checkbox"
												v-model="item.ischecked" @change="conversantToggle('tem')"></span>
										<span class="title fl"
											@click="routerlinkid('/enterprises', item.stockCode)">{{ item.title }} </span>
										<span class="delatebtn curp fr" @click="delatefun(1, item.title)">删除</span>
									</li>
								</ul>
							</div>
							<div class="fr">
								<div class="titlebox">
									<h5 class="fl">我想联系的企业</h5>
									<span class="addclick basebtn fr"
										@click="showtype = 'chooseContact'; popbtn = true; tipstext = ''; tipstext1 = '';">{{ contactlistTem.length > 0 ? '修改' : '添加' }}</span>
								</div>
								<ul>
									<li :key="index" v-for="(item, index) in contactlistTem">
										<span class="title fl"
											@click="routerlinkid('/enterprises', item.stockCode)">{{ item.title }} </span>
										<span class="fr smcalcuBtn basebtn" @click="calculatorFun('tem', item)"
											v-show="conversantlistCheckedTem.length > 0">计算</span>
										<!-- <span  class="fr smcalcuBtn disablebtn" v-show="iscalcu">计算中</span>  -->
										<span class="delatebtn curp fr" @click="delatefun(2, item.title)">删除</span>
									</li>
								</ul>
							</div>
						</div>
						<div class="relationCa oh" v-show="pagetype == 2">
							<div class="fl">
								<div class="titlebox">
									<h5 class="graybtn ">我熟悉的企业</h5>
									<!-- <span class="addclick basebtn fr"	@click="showtype='chooseconversant';popbtn=true;tipstext='';tipstext1='';">添加</span> -->
								</div>
								<ul>
									<li :key="index" v-for="(item, index) in conversantlist"
										v-show="item.enterpriseRelationId > 0">
										<span class="fl"><input type="checkbox" class="websit-checkbox"
												v-model="item.ischecked" @change="conversantToggle('list')"></span>
										<span class="title fl"
											@click="routerlinkid('/enterprises', item.stockCode)">{{ item.title }} </span>
										<span class="delatebtn curp fr"
											@click="toggleRelationEnterprise(item, item.type)">删除</span>
									</li>
								</ul>
							</div>
							<div class="fr">
								<div class="titlebox">
									<h5 class="graybtn">我想联系的企业</h5>
									<!-- <span class="addclick basebtn fr"		@click="showtype='chooseContact';popbtn=true;tipstext='';tipstext1='';">{{contactlist.length>0?'修改':'添加'}}</span> -->
								</div>
								<ul>
									<li :key="index" v-for="(item, index) in contactlist"
										v-show="item.enterpriseRelationId > 0">
										<span class="title fl"
											@click="routerlinkid('/enterprises', item.stockCode)">{{ item.title }} </span>
										<span class="fr smcalcuBtn basebtn" @click="calculatorFun('list', item)"
											v-show="conversantlistChecked.length > 0">计算</span>
										<!-- <span  class="fr smcalcuBtn disablebtn" v-show="iscalcu">计算中</span>  -->
										<span class="delatebtn curp fr"
											@click="toggleRelationEnterprise(item, item.type)">删除</span>
									</li>
								</ul>
							</div>
						</div>

						<div class="fixedRelationSearch" v-show="popbtn">
							<div class="relationSearch">
								<span class="closebtn" @click="closefun"></span>
								<div class="searchbox"
									v-show="showtype == 'chooseContact' || showtype == 'chooseconversantSingle'">
									<input type="text" placeholder="请输入企业名称" v-model="searchtext" @keydown="searchenter"
										class="fl"
										v-show="showtype == 'chooseContact' || showtype == 'chooseconversantSingle'">
									<span class="basebtn fr" @click="searchcompany()">搜索</span>
								</div>
								<div class="searchbox" v-show="showtype == 'chooseconversant'">
									<p class="redfont">注:请输入正确的企业全称,每行最多一个企业。</p>
									<textarea class="textarea-inp" placeholder="请输入企业全称"
										v-model="batchSearchtext"></textarea>
									<span class="basebtn fr" @click="batchSearchCompany()">批量添加</span>
								</div>
								<p v-show="searchlist.length == 0" style="color: #999;">{{ tipstext }}</p>
								<table border="0" cellspacing="0" cellpadding="0" v-show="searchlist.length > 0">
									<tr>
										<th>企业名称</th>
										<th>地区</th>
										<th>企业实力</th>
										<th>操作</th>
									</tr>
									<tr :key="i" v-for="(list, i) in searchlist">
										<!-- :class="list.stockCode!=''?'curp':''" @click="routerlinkid('/enterprises',list.stockCode)" -->
										<td><span>{{ list.title }}</span></td>
										<td>{{ list.area }}</td>
										<td>{{ list.zs100000 }}</td>
										<td>
											<span :class="list.ischeck ? 'grayfont' : 'basefont'"
												@click="addcheck(list)">{{ list.ischeck ? '已' : '' }}{{ showtype ==
													'chooseContact' ?'选择':'添加'}}</span>
										</td>
									</tr>
								</table>
								<div class="checkoption oh"
									v-show="chooseContact.length > 0 || chooseconversant.length > 0">
									<h5 class="title fl">已选企业</h5>
									<div class="fl conright">
										<span class="fl" :key="index"
											v-for="(item, index) in chooseconversant">{{ item.title }}<em
												@click="delatefun(3, item.title)">-</em></span>
										<span class="fl" :key="index"
											v-for="(item, index) in chooseContact">{{ item.title }}<em
												@click="delatefun(4, item.title)">-</em></span>
									</div>
								</div>
								<div class="btnbox" v-show="chooseContact.length > 0 || chooseconversant.length > 0">
									<span class="savebtn basebtn fl" @click="savefun">确定</span>
									<span class="cancelbtn graybtn fr" @click="closefun">取消</span>
								</div>
							</div>
						</div>
					</div>
					<!--   style="min-height: 800px;" -->

					<div class="whitebox right_topbox calculatorResult" v-show="hascalcu">
						<p class="redfont">{{ tipstext1 }}</p>
						<!-- :class="iscalcu?'':'savebtn basebtn relationCabtn'"  -->
						<div class="savebtn graybtn relationCabtn">
							<img src="../../../src/assets/img/loading-2.gif" v-show="iscalcu" class="barLoading" alt="">
							{{ iscalcu ? '计算中' : '计算结果' }}
						</div>

						<div v-show="resultslist.length > 0">
							<table border="0" cellspacing="0" cellpadding="0" class="pagetable1" width="100%">
								<tr>
									<th style="width: 300px;">我熟悉的企业</th>
									<th colspan="3">中间关系</th>
									<th style="width: 300px;">我想联系的企业</th>
								</tr>
								<tr :key="i" v-for="(list, i) in resultslist" v-if="list.length == 3"
									v-show="list.relation[2].stockCode == resultdata.target">
									<td class="title" @click="routerlinkid('/enterprises', list.relation[0].stockCode)">
										{{ list.relation[0].title }}</td>
									<td style="width: 200px;" class="tac">
										<!-- ({{list.relation[1].type}}) -->
										<span v-if="list.relation[1].type == '供应商'"
											class="relationship-arrow">客户——供应商</span>
										<span v-if="list.relation[1].type == '客户'"
											class="relationship-arrow">供应商——客户</span>
										<span v-if="list.relation[1].type == '投资'"
											class="relationship-arrow">投资——融资</span>
										<span v-if="list.relation[1].type == '融资'"
											class="relationship-arrow">融资——投资</span>
										<span v-if="list.relation[1].type == '子公司'"
											class="relationship-arrow">母公司——子公司</span>
										<span v-if="list.relation[1].type == '母公司'"
											class="relationship-arrow">子公司——母公司</span>
										<span v-if="list.relation[1].type == '母公司'"
											class="relationship-arrow">子公司——母公司</span>
										<span v-if="list.relation[1].type == '投资机构'"
											class="relationship-arrow"><em>被投企业——投资机构</em></span>
										<span v-if="list.relation[1].type == '商会'"
											class="relationship-arrow"><em>成员——商会</em></span>
										<span v-if="list.relation[1].type == '协会'"
											class="relationship-arrow"><em>成员——协会</em></span>
									</td>
									<td style="width: 300px;" class="title"
										@click="routerlinkid('/enterprises', list.relation[1].stockCode)">
										{{ list.relation[1].title }}</td>
									<td style="width: 200px;" class="tac">
										<!-- ({{list.relation[2].type}}) -->
										<span v-if="list.relation[2].type == '供应商'"
											class="relationship-arrow">客户——供应商</span>
										<span v-if="list.relation[2].type == '客户'"
											class="relationship-arrow">供应商——客户</span>
										<span v-if="list.relation[2].type == '投资'"
											class="relationship-arrow">投资——融资</span>
										<span v-if="list.relation[2].type == '融资'"
											class="relationship-arrow">融资——投资</span>
										<span v-if="list.relation[2].type == '子公司'"
											class="relationship-arrow">母公司——子公司</span>
										<span v-if="list.relation[2].type == '母公司'"
											class="relationship-arrow">子公司——母公司</span>
										<span v-if="list.relation[2].type == '被投企业'"
											class="relationship-arrow"><em>投资机构——被投企业</em></span>
										<span v-if="list.relation[2].type == '商会成员'"
											class="relationship-arrow"><em>商会——成员</em></span>
										<span v-if="list.relation[2].type == '协会成员'"
											class="relationship-arrow"><em>协会——成员</em></span>
									</td>
									<td class="title" @click="routerlinkid('/enterprises', list.relation[2].stockCode)">
										{{ list.relation[2].title }}</td>
								</tr>
								<tr :key="i" v-for="(list, i) in resultslist" v-if="list.length == 2">
									<td class="title" @click="routerlinkid('/enterprises', list.relation[0].stockCode)">
										{{ list.relation[0].title }}</td>
									<td colspan="3" class="tac">
										<!-- ({{list.relation[1].type}}) -->
										<span v-if="list.relation[1].type == '客户'"
											class="relationship-arrow">客户————————————————供应商</span>
										<span v-if="list.relation[1].type == '供应商'"
											class="relationship-arrow">供应商————————————————客户</span>
										<span v-if="list.relation[1].type == '投资'"
											class="relationship-arrow">投资————————————————融资</span>
										<span v-if="list.relation[1].type == '融资'"
											class="relationship-arrow">融资————————————————投资</span>
										<span v-if="list.relation[1].type == '子公司'"
											class="relationship-arrow">母公司————————————————子公司</span>
										<span v-if="list.relation[1].type == '母公司'"
											class="relationship-arrow">子公司————————————————母公司</span>
									</td>
									<td class="title" @click="routerlinkid('/enterprises', list.relation[1].stockCode)">
										{{ list.relation[1].title }}</td>
								</tr>
							</table>
							<div class="btnbox oh" style="padding-bottom: 100px;">
								<span :class="saveresultbtn ? 'basebtn' : 'graybtn cua'"
									@click="saveResultdata()">保存结果</span>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="heightVh95 whitebox container-flex-center">
						<freeUserTips :type="4" :bgtype="0" isShowPageTitle="企业-企业 关系计算器"></freeUserTips>
					</div> 
				</div>
				<!-- index_left -->
			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'relationalCalculator',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])	},
	data() {
		return {
			userdata: {},
			pagetype: 1,//单个计算为1 批量计算为2
			title: '联系人关系计算器',
			hascalcu: false,
			iscalcu: false,
			tipstext: '',
			conversantlist: [],
			conversantlistChecked: [],
			contactlist: [],
			conversantlistTem: [],//临时熟悉列表
			contactlistTem: [],//临时联系列表
			conversantlistCheckedTem: [],//临时选择列表
			showtype: 'chooseconversant',
			chooseconvertext: "",
			saveconvertext: '',
			chooseContact: [],
			chooseconversant: [],
			popbtn: false,
			searchtext: "",
			batchSearchtext: '',//批量搜索文本
			searchlist: [],
			editbtn: false,
			tipstext1: '',
			// 计算器结果data存值分割线 {relation:[{stockCode:"",title:""}]}
			resultslist: [],
			guideid: "",
			resultdata: {},
			saveresultbtn: true,
		}
	},
	created() {
		this.userdata = this.getuseriformation();
	},

	mounted() {
		if(this.userdata.token){
			this.calculatorFun();
		}

	},
	methods: {
		//页面切换
		pageToggle(type) {
			this.pagetype = type;
			this.iscalcu = false;
			this.tipstext = "";
			this.tipstext1 = "";
			this.resultslist = [];
			this.resultdata = {};
			this.hascalcu = "";
			if (type == 2) {
				this.getEnterpriseList();
			}

		},
		getEnterpriseList() {
			this.bus.$emit('loading', true);
			var _this = this;
			var ajaxurl = this.$api.cyl.enterpriseRelation.enterpriseList();
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log('用户添加的熟悉联系列表', res.data);
				if (res.data.success) {
					let resdata = res.data.data;
					var sourcedata = resdata.source ? resdata.source : [], sourcedata1 = [];
					var targetdata = resdata.target ? resdata.target : [], targetdata1 = [];
					for (var i = 0; i < sourcedata.length; i++) {
						sourcedata1.push({ enterpriseRelationId: sourcedata[i].id, ischecked: false, stockCode: sourcedata[i].stockCode, title: sourcedata[i].title, type: sourcedata[i].type })
					}
					for (var i = 0; i < targetdata.length; i++) {
						targetdata1.push({ enterpriseRelationId: targetdata[i].id, hascalcu: false, stockCode: targetdata[i].stockCode, title: targetdata[i].title, type: targetdata[i].type })
					}
					_this.conversantlist = sourcedata1;
					_this.contactlist = targetdata1;
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) { });
		},
		conversantToggle(type) {
			if (type == 'list') {
				this.conversantlistChecked = this.conversantlist.filter(list => {
					return list.ischecked;
				})
			} else if (type == 'tem') {
				this.conversantlistCheckedTem = this.conversantlistTem.filter(list => {
					return list.ischecked;
				})
			}
			// alert(88888)
		},
		searchenter(e) {
			if (e.keyCode == 13) {
				this.searchcompany();
			}
		},
		closefun() {
			this.popbtn = false;
			this.searchlist = [];
			this.searchtext = '';
			this.chooseContact = [];
			this.chooseconversant = [];
			this.chooseconvertext = '';
			this.batchSearchtext = '';
		},
		//批量搜索企业
		batchSearchCompany() {
			console.log(this.batchSearchtext);
			// 去除输入内容中的空格
			this.batchSearchtext = this.batchSearchtext.trim();
			// 将多行文本框的内容分割成数组
			var batchSearchtextTem = this.batchSearchtext.split('\n');
			// 将数组中的元素拼接成字符串
			batchSearchtextTem = batchSearchtextTem.join(',');
			console.log('拼接后', batchSearchtextTem);
			var _this = this;
			var ajaxurl = this.$api.cyl.enterpriseRelation.search();
			$.ajax({
				type: "POST",
				url: ajaxurl,
				data: { title: batchSearchtextTem },
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					console.log(res);
					if (res.success) {
						console.log(res);
						var dataList = res.list;
						if (dataList.length == 0) {
							_this.$message({
								type: 'warning',
								message: '没有找到您需要的企业，请输入正确的企业全称',
							});
							return;
						}
						// else{
						var conversantlist = _this.conversantlistTem;
						if (conversantlist.length > 0) {//当熟悉列表中有企业时，要去判断新添加的企业中是否有重复的，重复则剔除
							console.log('列表中有数据', conversantlist.length, dataList.length)
							for (var i = 0; i < conversantlist.length; i++) {
								for (var n = 0; n < dataList.length; n++) {
									console.log(dataList[n].title, conversantlist[i].title);
									if (conversantlist[i].stockCode == dataList[n].stockCode) {
										console.log('重复的企业名称', dataList[n].title);
										_this.$notify({
											type: 'warning',
											message: dataList[n].title + '已存在于熟悉企业列表中',
										});

									}
								}
							}
							dataList.forEach(list => {
								_this.conversantlistTem.push(list);
							})
							const uniqueArr = Array.from(new Set(_this.conversantlistTem.map(JSON.stringify))).map(JSON.parse);
							console.log('去重', uniqueArr);
							_this.conversantlistTem = uniqueArr;
						} else {
							console.log('熟悉列表为空');
							_this.conversantlistTem = dataList;
						}
						_this.popbtn = false;
						_this.batchSearchtext = '';

					}
					_this.errortext = res.msg;
				}
			});
		},
		searchcompany() {
			this.searchtext = $.trim(this.searchtext);
			var _this = this;
			this.bus.$emit('loading', true);
			var ajaxurl = this.$api.cyl.enterprise.list() + '?page=1&type=0&search=1&kw=' + this.searchtext;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log('搜索列表', res.data);
				if (res.data.success) {
					_this.searchlist = res.data.list.slice(0, 10);
					_this.searchlist.forEach(list => {
						list.ischeck = (_this.saveconvertext.indexOf(list.title) > -1 || _this.chooseconvertext.indexOf(list.title) > -1) && _this.showtype == 'chooseconversantSingle';
					})
					_this.tipstext = '没有找到您需要的企业，请输入正确企业名称';
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) { });
		},
		addcheck(list) {
			//chooseContact:[],chooseconversant:[],
			if (!list.ischeck) {
				if (this.showtype == 'chooseContact') {
					this.chooseContact = [{
						stockCode: list.stockCode,
						title: list.title
					}];
					this.searchlist.forEach(item => {
						if (item.title == list.title) {
							item.ischeck = true;
						} else {
							item.ischeck = false;
						}
					})
				} else if (this.showtype == 'chooseconversantSingle') {
					if (this.chooseconvertext.indexOf(list.title) < 0) {
						this.chooseconversant.push({
							stockCode: list.stockCode,
							title: list.title,
							ischecked: false,
						});
						this.chooseconvertext = this.chooseconvertext + list.title + ',';
						this.searchlist.forEach(item => {
							if (item.title == list.title) {
								item.ischeck = true;
							}
						})

					}


				}
			}
		},
		//小删除 临时计算列表引用
		delatefun(type, title) {
			this.tipstext1 = "";
			//type 1234  chooseconversant  chooseContact   conversantlist contactlist
			if (type == 1) {
				this.conversantlistTem = this.conversantlistTem.filter(list => {
					return list.title != title;
				})
			} else if (type == 2) {
				this.contactlistTem = this.contactlistTem.filter(list => {
					return list.title != title;
				})
			} else if (type == 3) {
				this.chooseconversantTem = this.chooseconversantTem.filter(list => {
					return list.title != title;
				});
			} else if (type == 4) {
				this.chooseContact = this.chooseContact.filter(list => {
					return list.title != title;
				})
			}
			if (type == 3 || type == 4) {
				this.searchlist.forEach(list => {
					if (list.title == title) {
						list.ischeck = false;
					}
				})
			}
		},
		//搜索公司名字后保存结果 临时列表引用
		savefun() {
			if (this.showtype == 'chooseContact') {
				this.contactlistTem = this.chooseContact;
			} else if (this.showtype == 'chooseconversant' || this.showtype == 'chooseconversantSingle') {

				this.conversantlistTem = this.conversantlistTem.concat(this.chooseconversant);
				var dddgs = '';
				for (var i = 0; i < this.conversantlistTem.length; i++) {
					dddgs = dddgs + this.conversantlistTem[i].title + ',';
				}
				this.saveconvertext = dddgs;
			}
			this.closefun();
		},
		//开始计算 stocktype=all 为左边全部  stocktype为stockcode则为单个
		calculatorFun(type, item) {
			this.hascalcu = true;
			this.tipstext1 = "";
			if (this.iscalcu && item.hascalcu) {
				return;
			}
			var _this = this;
			this.iscalcu = true;
			var conversantText = '', contactText = '';
			if (type == 'list') {
				for (var i = 0; i < this.conversantlistChecked.length; i++) {
					let dd = i == 0 ? '' : ',';
					conversantText = conversantText + dd + this.conversantlistChecked[i].stockCode;
				};
			} else if (type == 'tem') {
				for (var i = 0; i < this.conversantlistCheckedTem.length; i++) {
					let dd = i == 0 ? '' : ',';
					conversantText = conversantText + dd + this.conversantlistCheckedTem[i].stockCode;
				};
			}

			// if (stocktype == 'all') {
			// 	contactText = this.contactlist[0].stockCode;
			// } else {
			// 	contactText = stocktype;
			// }
			contactText = item.stockCode;
			item.hascalcu = true;
			console.log(conversantText, contactText);
			// var testc = '300750,300769', testd = '10639809';
			// console.log(this.$api.cyl.enterpriseRelation.calculate() + '?sourceList=' + conversantText + '&target=' + contactText,)
			this.$axios.get(this.$api.cyl.enterpriseRelation.calculate() + '?sourceList=' + conversantText +
				'&target=' + contactText, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log('计算结果', res.data)
				if (res.data.success) {
					_this.resultslist = res.data.list ? res.data.list : [];
					if (res.data.list.length > 0) {
						_this.resultdata = res.data.data;
						_this.saveresultbtn = true;
					} else {
						_this.tipstext1 = '相熟企业和想联系企业暂无中间联系人'
					}

					_this.iscalcu = false;
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		saveResultdata() {
			var _this = this;
			var ajaxdata = this.resultdata;
			var ajaxurl = this.$api.cyl.enterpriseRelation.save();
			if (_this.saveresultbtn) {
				$.ajax({
					type: "POST",
					url: ajaxurl,
					data: ajaxdata,
					headers: {
						AuthToken: this.userdata.token
					},
					success: function (res) {
						console.log('1123', res);
						if (res.success) {
							_this.$message({
								type: 'success',
								message: '保存成功，可前往我的关系网查看',
							});
							// alert('保存成功，可前往我的关系网查看');
							_this.saveresultbtn = false;
						}
					}
				})
			}
		},
	}
}
</script>
<style lang="scss">
.textarea-inp {
	border: 1px solid #eee;
	height: 450px;
	width: 520px;
	padding-left: 20px;
	font-size: 16px;
	line-height: 28px;
	font-weight: 600;
}

.relationCa {
	.smcalcuBtn {
		height: 30px;
		margin: 15px 20px;
		line-height: 30px;
		width: 80px;
	}




	.titlebox h5.graybtn {
		width: 100%;
		height: 42px;
		line-height: 42px;
		font-size: 16px;
		font-weight: normal;
	}
}

.barLoading {
	width: 22px;
	height: 22px;
	position: relative;
	top: 5px;
	right: 10px;
}

.user_tabtitle1 {
	height: 38px;
	line-height: 38px;
	margin-bottom: 32px;
}

.user_tabtitle1 li {
	width: calc(50% - 4px);
	text-align: center;
	cursor: pointer;
	font-size: 16px;
	text-align: center;
	border: 1px solid #5E83CC;

	&.current,
	&:hover {
		background: #5E83CC;
		color: #fff;
	}
}
</style>
